import axios from 'axios';
import { format } from 'date-fns';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Badge } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import '../common-css/Table.css';
import { showTableResponse } from '../common-helpers/commonServices';
import LiveStreamingChatModal from './LiveStreamingChatModal';
import LiveSteamingModal from './LiveStreamingModal';
import RescheduleStreamingModal from './RescheduleStreamingModal';
import { CiEdit } from 'react-icons/ci';



const TopicDetails = () => {
    const childRef = useRef();
    const chatRef = useRef();
    const location = useLocation();
    const navigate = useNavigate();
    const [topics, setTopics] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [checked, setChecked] = useState(topics);
    const [loadTopics, setTopicsLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [updateCourseId, setUpdateCourseId] = useState(null);

    const [rescheduleSessionModal, setRescheduleSessionModal] = useState(false);
    const [updateDate, setUpdateDate] = useState(null);

    const pageSize = 20;
    const lastIndex = currentPage * pageSize;
    const firstIndex = lastIndex - pageSize;
    const records = checked?.slice(firstIndex, lastIndex);

    // 1. Wrap in useCallback to prevent unnecessary recreations
    const fetchClasses = useCallback((showLoading = true) => {
        if (showLoading) setLoading(true);
        axios.get(BACKEND_SERVER_URL + '/streaming_links')
            .then((res) => {
                let streamings = res.data.streamings || [];
                setTopics(streamings);
                setChecked(streamings);
            })
            .catch((error) => {
                const msg = error?.response?.data?.message || 'Unable to fetch live streams';
                toast.error(msg);
            })
            .finally(() => { if (showLoading) setLoading(false) });
    }, []); // No dependencies implies it's stable

    // 3. Update the reload trigger effect
    useEffect(() => {
        fetchClasses(true);
    }, [loadTopics, fetchClasses]);

    // 4. Update the Timer Effect
    useEffect(() => {
        const now = Date.now();
        // Ensure we parse dates correctly
        const upcoming = topics
            .map((c) => new Date(c.StartDate).getTime())
            .filter((time) => time > now);

        if (upcoming.length > 0) {
            const nextTime = Math.min(...upcoming);
            const timeout = nextTime - now;

            // 32-bit integer limit check
            if (timeout < 2147483647) {
                // Add buffer (e.g. 5 seconds) to ensure server side status has flipped
                const timer = setTimeout(() => {
                    fetchClasses(false);
                }, timeout + 5000);
                return () => clearTimeout(timer);
            }
        }
    }, [topics, fetchClasses]);

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const d = new Date(dateString); // "Z" ensures this converts to Local Time
        return format(d, "dd MMM, hh:mm a"); // Using your imported date-fns format
    };

    const isFuture = (dateString) => {
        return new Date(dateString).getTime() > Date.now();
    };
    const goLive = async (link) => {
        try {
            const broadcastId = (link && link.includes('v=')) ? link.split('v=')[1] : link;
            const response = await axios.get(BACKEND_SERVER_URL + '/go-live/' + broadcastId);
            toast.success('Going live...');
            setTopicsLoading(prev => !prev);
        } catch (error) {
            console.log(error.message);
            toast.error("Error in going live");
        }
    }
    const endLive = async (item) => {
        try {
            const broadcastId = (item?.Link && item.Link.includes('v=')) ? item.Link.split('v=')[1] : item?.Link;
            const response = await axios.get(BACKEND_SERVER_URL + '/end-live/' + item.Sn + "/" + broadcastId);
            toast.success('Live ended');
            setTopicsLoading(prev => !prev);
        } catch (error) {
            console.log(error.message);
            toast.error("Error in end live");
        }
    }

    const openRescheduleModal = (courseId, date) => {
        setUpdateCourseId(courseId);
        setRescheduleSessionModal(true);
        setUpdateDate(date);
    }

    const deleteSession = async (sn) => {
        try {
            const shouldDelete = window.confirm('Are you sure you want to delete this session?');
            if (!shouldDelete) return;
            const response = await axios.delete(BACKEND_SERVER_URL + '/delete-live-stream/' + sn);
            toast.success('Session deleted');
            setTopicsLoading(prev => !prev);
        } catch (error) {
            console.log(error.message);
            toast.error("Error in delete session");
        }
    }



    const copyKey = async (key) => {
        try {
            await navigator.clipboard.writeText(key || '');
            toast.success('Stream key copied');
        } catch (err) {
            console.error(err);
            toast.error('Unable to copy');
        }
    }
    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className=" page-title p-2 mb-2">{/*  flex-wrap  */}
                                <div className=' col-12  d-flex justify-content-between'>
                                    <button type="button" className="btn btn-dark btn-sm me-2"
                                        onClick={() => childRef.current.openModal()}
                                    >
                                        + Create Live Streaming
                                    </button>
                                    <button type="button" className="btn btn-dark btn-sm me-2"
                                        onClick={() => window.open(BACKEND_SERVER_URL + '/auth')}
                                    >
                                        Authorize Users
                                    </button>

                                    {/* <div className="col-4">
                                        <div className="basic-dropdown">
                                            <Select
                                                value={{ value: selectedCourse, label: selectedCourse.courseTitle }}
                                                onChange={(selectedOption) => selectCourseHandler(selectedOption.value)}
                                                options={courses?.map((course) => ({ value: course, label: course.courseTitle }))}
                                                styles={setDropDownStyle()}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="basic-dropdown ms-1">
                                            <Select
                                                value={{ value: selectedSubject, label: selectedSubject.subject }}
                                                onChange={(selectedOption) => selectSubjectHandler(selectedOption.value)}
                                                options={courseWiseSubjects?.map((subject) => ({ value: subject, label: subject.subject }))}
                                                styles={setDropDownStyle()}
                                            />
                                        </div>
                                    </div> */}

                                </div>

                            </div>
                        </div>
                        <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                            <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                                <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                    <table className="table-responsive-lg table display dataTablesCard student-tab 
                                    dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }} id="example-student" >
                                        <thead style={{ backgroundColor: "#cccccc" }}>
                                            <tr className='text-center text-dark border border-left'>
                                                <th className='p-2 text-start custom-table-header '>S no</th>
                                                <th className='p-2 text-start custom-table-header '>LIVE CLASS TITLE</th>
                                                <th className=' text-start custom-table-header  p-2' >COURSE/TESTSERIES</th>
                                                <th className=' text-start custom-table-header  p-2' >DATE AND TIME</th>
                                                <th className='custom-table-header  p-2' >CLASS STATUS</th>
                                                <th className='custom-table-header  p-2' >CHAT</th>
                                                <th className='custom-table-header  p-2' >END LIVE</th>
                                                <th className='custom-table-header  p-2' >STREAM KEY</th>
                                                <th className='custom-table-header  p-2' >DELETE LINK</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {records.length > 0 ? records.map((item, ind) => (
                                                <tr key={ind} className={`${ind % 2 == 1 ? 'custom row-height' : 'row-height'}`} >
                                                    {/* <td className='text-start p-1 active-col-width' style={{ border: "1px solid #cccccc", width: "80px" }}>
                                                        {item.Status == 1 && <h6 className="text-success mb-0 ">Active </h6>}
                                                        {item.Status == 0 && <h6 className="text-danger mb-0">Inactive </h6>}
                                                    </td> */}
                                                    <td className='p-1' style={{ border: "1px solid #cccccc" }}>

                                                        <h6 className='mb-0 ' style={{ fontSize: '13px', fontWeight: 'bold' }}>{ind + 1}.

                                                        </h6>

                                                    </td>
                                                    <td className='p-1' style={{ border: "1px solid #cccccc" }}>

                                                        <h6 className='mb-0 ' style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.Title}

                                                        </h6>

                                                    </td>
                                                    <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                                                        <div className="d-flex justify-content-between ">
                                                            <h6 className='mb-0 ' style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.CourseName}
                                                                {/* <CiEdit cursor='pointer' title='Edit Topic' size={18} className='ms-3'
                                                                    onClick={() => childRef.current.openModal(item.sn)} />
                                                                <MdDeleteOutline color="red" title='Delete Topic' cursor='pointer' size={18} className='ms-2' onClick={() => { deleteItem(item.sn, 'Topic', '/deleteTopic/', setTopicsLoading, loadTopics) }}

                                                                /> */}
                                                            </h6>
                                                        </div>
                                                    </td>

                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc" }} >
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            <h6 className="mb-0 me-2">{formatDate(item.StartDate)}</h6>
                                                            <CiEdit cursor='pointer' title='Edit Date' size={18} className='ms-3' onClick={() => openRescheduleModal(item.Link.replace("https://www.youtube.com/watch?v=", ""), item.StartDate)} />
                                                        </div>
                                                    </td>

                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc" }} >
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            <h6 className="mb-0 me-2">{item.Status == 2 ? 'Class Over' : isFuture(item.StartDate) ? 'Upcoming' : 'Started'}</h6>
                                                            {/* <button className="btn btn-sm btn-light" onClick={() => copyKey(item.Status)}>Change</button> */}
                                                        </div>
                                                    </td>
                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc" }}>
                                                        <button className="btn btn-sm btn-outline-secondary" onClick={() => chatRef.current?.openModal(item)}>Chat</button>
                                                    </td>
                                                    <td
                                                        className="p-1 text-center cursor-pointer"
                                                        style={{ border: "1px solid #cccccc" }}
                                                    >
                                                        <h6 className="mb-0">
                                                            <Badge
                                                                bg=""
                                                                disabled={item.Status != 1}
                                                                className="badge-primary light badge-sm ms-2 cursor-pointer pe-3 ps-3"
                                                                onClick={() => endLive(item)}
                                                            > End Live

                                                            </Badge>
                                                        </h6>
                                                    </td>
                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc" }} >
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            <h6 className="mb-0 me-2">{item.StreamingKey}</h6>
                                                            <button className="btn btn-sm btn-light" onClick={() => copyKey(item.StreamingKey)}>Copy</button>
                                                        </div>
                                                    </td>

                                                    <td
                                                        className="p-1 text-center cursor-pointer"
                                                        style={{ border: "1px solid #cccccc" }}
                                                    >
                                                        <h6 className="mb-0">
                                                            <Badge
                                                                bg=""
                                                                className="badge-primary light badge-sm ms-2 cursor-pointer pe-3 ps-3"
                                                                onClick={() => deleteSession(item.Sn)}
                                                            > Delete Session

                                                            </Badge>
                                                        </h6>
                                                    </td>

                                                </tr>
                                            )) : loading ?
                                                <tr>
                                                    <td colSpan="6" className="text-center">
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                                            {
                                                                showTableResponse(topics, checked)
                                                            }
                                                        </div>
                                                    </td>
                                                </tr> :
                                                <tr>
                                                    <td colSpan="6" className="text-center">
                                                        <p>No Streams Found</p>
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <LiveSteamingModal ref={childRef} loadTopics={loadTopics} setTopicsLoading={setTopicsLoading} />
            <LiveStreamingChatModal ref={chatRef} />
            {rescheduleSessionModal && <RescheduleStreamingModal courseID={updateCourseId} date={updateDate} setTopicsLoading={setTopicsLoading} setRescheduleSessionModal={setRescheduleSessionModal} />}
        </>
    )
}

export default TopicDetails;

